import { api, qs } from './base';
import type { LearnedContextRow, ListResponse } from '@/common/types';

/** Active learned lessons for a repo (loadContext layer 3 contents). */
export function listLearnedContext(repo: string): Promise<ListResponse<LearnedContextRow>> {
  return api.get<ListResponse<LearnedContextRow>>(`/learned-context${qs({ repo })}`);
}

/** Admin retire a learned entry so it stops loading. */
export function retireLearnedContext(repo: string, entryId: string, actor: string) {
  return api.post(`/learned-context/retire${qs({ repo, entryId })}`, { repo, entryId, actor });
}
